import { MatchSearchList } from 'components/MatchSearchList.jsx';
import { Match } from 'models/Match.jsx';

import store from 'react/redux/store/store';
import * as matchmakingActions from 'react/redux/actions/matchmaking';

class MatchSearchListManager {
	constructor() {
		this.rankedSearches = new MatchSearchList(this, 'Ranked', (match) => {
			return match.isRanked();
		});
		this.unrankedSearches = new MatchSearchList(this, 'Unranked', (match) => {
			return !match.isRanked();
		});
		this.matchLists = [
			this.rankedSearches,
			this.unrankedSearches
		];
		this.activeMatch = null;

		setTimeout(() => {
			store && store.dispatch(matchmakingActions.setMatchSearchListManager(this));
		}, 1);

		setInterval(this.checkMatches.bind(this), 5000);
	}

	findMatchById(matchId) {
		for(let matchList of this.matchLists) {
			const match = matchList.getMatchFromMatchData({ id: matchId });
			if(match) {
				return match;
			}
		}
		return null;
	}

	hasAutoQueueMatchCreatedByMe() {
		for(let matchList of this.matchLists) {
			for(let [_, match] of matchList.matches) {
				if(match.isMySearch() && match.isAutoQueued()) {
					return true;
				}
			}
		}
		return false;
	}

	hasMatchWithCriteria({ players, ladderId, gameCount, isRanked, teamSize, isSearch }) {
		this.instantlyRemoveAllOldMatches();
		for(let matchList of this.matchLists) {
			const match = matchList.getMatchWithCriteria({
				players,
				ladderId,
				gameCount,
				isRanked,
				teamSize,
				isSearch
			});
			if(match) {
				return match;
			}
		}
	}

	instantlyRemoveAllOldMatches() {
		for(let matchList of this.matchLists) {
			matchList.checkMatches({ instantlyRemove: true });
		}
	}

	clearAll() {
		for(let matchList of this.matchLists) {
			matchList.clear();
		}
	}

	checkMatches() {
		for(let matchList of this.matchLists) {
			matchList.checkMatches();
			matchList.removePendingMatches();
		}
	}

	removeSearch(matchId) {
		for(let matchList of this.matchLists) {
			matchList.removeMatch({ match: matchId });
			matchList.checkMatches();
		}
	}

	clearActiveMatch() {
		this.setCurrentMatch(null);
	}

	setCurrentMatch(match) {
		const hadActiveMatch = !!this.activeMatch;
		if(match) {
			const tempMatch = Match.create({ id: match.id });
			if(this.activeMatch) {
				if(this.activeMatch.id === tempMatch.id) {
					this.activeMatch.update(match);
					if(!this.activeMatch.shouldViewLobby()) {
						this.activeMatch = null;
					}
				}
				else {
					this.activeMatch = Match.retrieve(match);//Using retrieve to keep it synced with the old code
				}
			}
			else {
				this.activeMatch = Match.retrieve(match);
			}
		}
		else {
			this.activeMatch = null;
		}
		if(this.activeMatch) {
			this.checkCurrentMatchState(this.activeMatch);
		}
		store.dispatch(matchmakingActions.currentMatchUpdate(this.activeMatch));
	}

	checkCurrentMatchState(match) {
		if(match.isEnded()) {
			if(match.atLeastOneOtherPlayerIsChatting()) {
				match.chatMessages.closed = false;
			}
			else {
				if(match.chatMessages) {
					match.chatMessages.closed = true;
				}
			}
		}
	}

	parseSearches(searches) {
		if(searches.all_entries) {
			delete searches.all_entries;
		}
		for(let i in searches) {
			if(!searches.hasOwnProperty(i)) {
				continue;
			}
			const search = searches[i];
			if(!search.id) {
				search.id = i;
			}
			this.parseMatchData(search);
		}
		this.checkMatches();
	}

	parseMatchData(match) {
		if(!match.id) {
			console.log(match);
			throw new Error('Match needs an id fool!');
		}
		let list = null;
		const parsedMatch = Match.create(match);

		if(parsedMatch.shouldViewLobby() || (this.activeMatch && this.activeMatch.id === parsedMatch.id)) {
			this.setCurrentMatch(match);
		}
		if(match.is_ranked) {
			list = this.rankedSearches;
		}
		else {
			list = this.unrankedSearches;
		}

		if(match.is_removed) {
			this.removeSearch(match);
		}
		else {
			list.updateMatch(match);
		}
	}

	getCurrentMatch() {
		return this.activeMatch;
	}
}

const matchSearchListManager = new MatchSearchListManager();
export { matchSearchListManager };